var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auditStatistics)?_c('number-card',{attrs:{"primary":"","bold":"","amount":_vm.inspections,"title":_vm.$it('dashboard.card.inspections-this-month.title', 'Inspections this month')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }